import ProductCard     from "components/Product/ProductCard"
import ProductListItem from "components/Product/ProductListItem"

import _            from "lodash"
import { observer } from "mobx-react"

import CategoryShortcuts                                                                             from "plugin/CategoryShortcuts/CategoryShortcuts"
import CategoryDropdown                                                                              from "components/Category/CategoryDropdown"
import queryString                                                                                   from "qs"
import React, { Component }                                                                          from "react"
import { Link, NavLink, withRouter }                                                                 from "react-router-dom"
import { Accordion, Button, Card, Container, Dropdown, Form, Icon, Menu, Pagination, Radio, Sticky } from "semantic-ui-react"
import shop                                                                                          from "shop/shop"
import categoryStore                                                                                 from "stores/categoryStore"
import cmsStore                                                                                      from "stores/cmsStore"
import MediaQuery                                                                                    from "react-responsive"

import productStore from "stores/productStore"

import colors                    from "style/colors"

import "style/FilterPage.scss"
import historyStore              from "stores/historyStore"
import WordPress                 from "WordPress"
import { ProductServiceContact } from "../theme/orfix/pages/ProductServiceContact";
import { slugify }               from "../sdk/slugify";
import WordPressShopComponent    from "../components/WordPressShopComponent/WordPressShopComponent";
import { SEOCategory }           from "../components/SEO";
import FilterSortBy              from "components/Filter/FilterSortBy"

const lastFilters = {}

@observer
export default class FilterPage extends Component {

  state = {
    products: [],
    showSidebar: true,
    size: 0,
    showDrawer: false
  }

  handleClear = () => {
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    const reset = {
      dir: query.dir,
      count: query.count,
      sort: query.sort,
      view: query.view,
    }
    this.props.history.replace( { search: queryString.stringify( reset ) } )
  }

  componentWillReceiveProps( props ) {
    const { categories } = props.match.params
    const { search } = props.location

    if ( this.search !== search || categories !== this.categories ) {
      this.load( props )
    }

    this.categories = categories
    this.search = search
  }

  componentDidMount() {

    const query = queryString.parse( this.props.location.search.substr( 1 ) ) || {}
    if ( !query.sort ) {
      return this.props.history.replace( { search: getDefaultFilterSearch() } )
      // return <Redirect replace to={{search: getDefaultFilterSearch()}} />
    }
    this.load()
  }

  componentDidUpdate() {
    _.debounce( this.load, { trailing: true }, 250 )
  }

  toggleSidebar = () => {
    this.setState( { showSidebar: !this.state.showSidebar } )
  }

  load = ( props = this.props ) => {
    this.setState( { loading: true } )
    const query = queryString.parse( props.location.search.substr( 1 ) )
    const { categories = "" } = props.match.params
    const parentCategories = categories.split( "/" )
    const categoryId = decodeURIComponent(parentCategories.pop())
    const category = categoryStore.categoriesById.get( categoryId )

    // TODO: NOT EVERY CATEGORY STORE SUPPORTS THIS
    // categoryStore.fetchCategoryMeta && categoryStore.fetchCategoryMeta( categoryId )

    const { page = 1, count = shop.config.standards.ITEMS_PER_PAGE } = query
    let filters = []
    const fields = _.pick( query, shop.config.pickFilter )
    const filterSize = _.size( fields )

    _.forEach( fields, ( value, key ) => {

      // MULTIFILTERS ARE ADDED AS "OR"
      if ( Array.isArray( value ) ) {
        let queryFilters = value.map( v => {
          return {
            op: "equals",
            extra: true,
            field: key,
            value: v
          }
        } )

        let combinedFilter = { "or": queryFilters }
        filters.push( combinedFilter )

      } else {
        let filter = {
          op: "equals",
          extra: true,
          field: key,
          value: value
        }
        filters.push( filter )
      }
    } )

    // Only hide variants if we don't search by filter
    // i.e. user searches for color only available on variants
    if ( cmsStore.config.plugin.hideVariants ) {
      // FILTER ALL VARIANTS (ONLY MAIN-ARTCILES)
      let noVariants = {
        op: "equals",
        field: "type",
        value: "1"
      }
      const singleItems = { "field": "mainArticle", "op": "equals", "value": "" }
      let combinedFilter = [{ "or": [singleItems, noVariants] }]
      filters = filters.concat( combinedFilter ) // this shows only mainarticles (i.e. no-variants))
    }
    
    if ( categoryId ) {
      productStore.fromCategory( categoryId, {
        value: "%%",
        dir: query.dir || shop.config.standards.DIR || "des",
        sort: query.sort || shop.config.standards.SORT || "sort",
        page,
        count: count || shop.config.standards.ITEMS_PER_PAGE,
      }, filters )
                  .then( res => {
                    if ( !res.products.length ) {

                      let catQuery = {
                        value: "",
                        dir: query.dir || shop.config.standards.DIR || "des",
                        sort: query.sort || shop.config.standards.SORT || "sort",
                        page,
                        count: count || shop.config.standards.ITEMS_PER_PAGE,
                      }

                      let additionalFilters = filters.filter( e => e.field !== "type" )
                      
                      // console.info( "NO VARIANTS FOUND - FALLBACK TO 'SHOW ALL'" )
                      return productStore.fromCategory( categoryId, catQuery, additionalFilters )
                                         .then( res => {
                                           let { products } = res
                                           if ( products.length === 0 ) {
                                             if ( products.length === 0 && shop.config.collections.showProductsFromSubCategories ) {
                                               // get products from all child categories

                                               const mapChildren = cat => {
                                                 if ( cat.children.length > 0 ) return _.map( cat.children, mapChildren )
                                                 return cat.map_id
                                               }

                                               const ids = _.flatten( category && category.children.map( mapChildren ) )
                                               if ( ids.length > 0 ) {
                                                 return productStore.fromCategory( ids, catQuery, additionalFilters )
                                               }
                                             }
                                           }

                                           return res
                                         } )
                    }
                    return res
                  } )
                  .then( res => {
                    let { products, size } = res
                    this.setState( { products, size, filterCount: fields && fields.length, loading: false } )
                    return res
                  } )
    } else {
      productStore.query( {
                            value: "%%",
                            filter: [...filters],
                            dir: query.dir || shop.config.filter_defaults.sort || "des",
                            sort: query.sort || shop.config.filter_defaults.sort,
                            page,
                            count: count || shop.config.standards.ITEMS_PER_PAGE,
                          } )
                  .then( res => {
                    lastFilter = this.props.location.search
                    let { products, size } = res
                    this.setState( { products, size, filterCount: fields && fields.length, loading: false } )
                  } )
    }
  }

  handleSortChange = ( sort ) => {
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    query.sort = sort
    this.props.history.replace( { search: queryString.stringify( query ) } )
  }

  handleCountChange = ( count ) => {
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    query.count = count
    this.props.history.replace( { search: queryString.stringify( query ) } )
  }

  handleDirectionChange = ( dir ) => {
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    query.dir = dir
    this.props.history.replace( { search: queryString.stringify( query ) } )
  }

  render() {
    const { categories = "" } = this.props.match.params
    const { useEditor } = cmsStore

    const parentCategories = categories.split( "/" )
    const depth = parentCategories.length
    const categoryId = parentCategories.pop()
    const category = categoryStore.categoriesById.get( categoryId )
    let path = shop.getCategoryPath( categoryId )

    let showProductSearch = true
    const query = queryString.parse( this.props.location.search.substr( 1 ) ) || {}
    const view = query.view || shop.config.filter_defaults.view || "grid"

    const { sort = shop.config.filter_defaults.sort } = query
    const { dir = shop.config.filter_defaults.dir || "asc" } = query

    let count = getFilterCount( query )

    const { products, showSidebar, showDrawer, size } = this.state

    let loading = productStore.loading || this.state.loading

    let filterFields = categoryStore.rootFields
    if ( category ) {
      filterFields = category.meta.fields || category.meta.submeta.fields
      if ( category.children.length > 1 ) {
        showProductSearch = true
      }
    }


    let page = cmsStore.contentByCategory.get( `${categoryId}` )
    const useCreateContent = !page && useEditor
    const useEditContent = page && useEditor


    const currentSearch = queryString.stringify( {
                                                   referrerTitle: category && category.title,
                                                   referer: `${this.props.location.pathname}${this.props.location.search}`
                                                 } )

    return <div className={"FilterPage"}>
      <SEOCategory category={category}/>
      {/* FILTER DRAWER MOBILE*/}
      <MediaQuery maxWidth={1024}>
        <div
          className={`FilterDrawer fixed z-999 bottom-0 right-0 left-0 animate ${showDrawer ? "fadeInUp" : "slideOutDown"}`}>

          <div className="wrapper">
            <Sticky>
              <div className="  z-6 left-0 right-0 pa2 bg-white flex justify-between items-center">
                <div className="animate fadeInDown w-100">

                  <Button floated="right" icon={"chevron down"} onClick={() => {
                    this.setState( { showDrawer: !showDrawer } )
                  }}
                  />
                  <div
                    className="pt2 mt1 pl3 black-60 f6">{size} {translate( "Produkte gefunden" )}</div>

                </div>
              </div>
            </Sticky>
            <FilterNavigation
              location={this.props.location}
              key={this.props.location.search}
              showChildCategories
              defaultOpen
              filterFields={filterFields}
              query={query}
              category={category}/>
          </div>
        </div>

        <div className="fixed bottom-1 left-1 right-1 z-5 tc">
          <Button primary circular
                  size={"small"}
                  onClick={() => {
                    this.setState( { showDrawer: !showDrawer } )
                  }}
          ><Icon name="filter"/>{count !== 0 ? count : ""} FILTER </Button>
        </div>
      </MediaQuery>

      <Container>
        <MediaQuery minWidth={"1100px"}>
          <div className="pt3">
            <Menu>

              <CategoryDropdown category={category} current={`/collection/${categories}`}/>
              {path.map( ( item, index ) => <Menu.Item key={item.title} as={NavLink} to={item.link}
                                                       exact>{item.title}</Menu.Item> )}

              {/*<Menu.Item>*/}
              {/*<Input placeholder="Suche"/>*/}
              {/*</Menu.Item>*/}
            </Menu>
          </div>
        </MediaQuery>


        {/* WORDPRESS CONTENT*/}
        {useCreateContent && <div className="editor-start mt4 pa4 ba bw2 b--silver b--dashed mb4 relative flex flex-row justify-center">
          <Button primary target={"_blank"} as={"a"}
                  href={`${shop.config.BASE}/wp/wp-admin/post-new.php?post_type=shop&category=${categoryId}&categoryTitle=${categoryId}&categoryId=${`${categoryId}`}`}><Icon
            name={"wordpress"}/> Inhalt hinzufügen</Button>
        </div>}




        {(shop.config.plugin[ "categoryShortcuts" ] && depth < 5) &&
          <div className="pt3">
            <CategoryShortcuts category={category}/>
          </div>}


        {showProductSearch && <React.Fragment>
          <div className="pt2 pb3">
            <Menu borderless secondary pointing className={"w-100"}>
              <Menu.Item
                className="filter-toggl"
                style={{ width: "180px", height: "40px" }}>
                <div className="f5 "><Link to={{ search: this.props.location.search }}
                                           onClick={this.toggleSidebar}>
                  {showSidebar && <Icon name="angle left"/>}
                  {!showSidebar && <Icon name="angle right"/>}
                  {translate( "Filter" )} {count > 0 && <span>{translate( "aktiv" )} <b>({count})</b></span>}</Link>
                  {(count > 0 && !loading) &&
                    <Button className="clear-filter clear-filter--all primary " circular icon={"close"}
                            size="tiny" onClick={this.handleClear}/>}
                  {loading &&
                    <Button className="clear-filter clear-filter--all" circular loading icon={"close"}
                            size="tiny"/>}
                </div>
              </Menu.Item>

              {/*<Menu.Menu position="right">*/}
              {/*/!*<Menu.Item active as={Link} to="./">Alles</Menu.Item>*!/*/}
              {/*/!*<Menu.Item as={Link} to="./">Basic</Menu.Item>*!/*/}
              {/*/!*<Menu.Item as={Link} to="./">Saison</Menu.Item>*!/*/}
              {/*/!*<Menu.Item as={Link} to="./">Sale</Menu.Item>*!/*/}
              {/*</Menu.Menu>*/}

              <Menu.Menu position="right">
                <Menu.Item>
                  <div className="f6"><SelectCount count={query.count}
                                                   onChange={this.handleCountChange}/></div>
                </Menu.Item>
                <Menu.Item>
                  <div className="f6"><FilterSortBy sort={sort} onChange={this.handleSortChange}/></div>
                </Menu.Item>
                {dir === "asc" && <Menu.Item as={Button} onClick={() => {
                  this.handleDirectionChange( "desc" )
                }} icon={"sort amount up"}/>}
                {dir === "desc" && <Menu.Item as={Button} onClick={() => {
                  this.handleDirectionChange( "asc" )
                }} icon={"sort amount down"}/>}
                <Menu.Item as={Link} active={view === "grid"}
                           to={{ search: queryString.stringify( { ...query, view: "grid" } ) }}
                           icon={"th"}/>
                <Menu.Item as={Link} active={view === "list"}
                           to={{ search: queryString.stringify( { ...query, view: "list" } ) }}
                           icon={"th list"}/>
              </Menu.Menu>
            </Menu>
          </div>


          <div className="flex ">
            <MediaQuery minWidth={1024}>
              <div className={`catalog-sidebar ${showSidebar ? " fadeInLeft" : "animate fadeOutLeft"}`}>

                <FilterNavigation
                  location={this.props.location}
                  category={category}
                  key={this.props.location}
                  filterFields={filterFields}
                  query={query}
                  className="pb3"/>

                {/*KATEGORIES*/}
                {/*<NavigationSidebar category={category}/>*/}
              </div>
            </MediaQuery>

            <div className="w-100">
              <div className="tc pb3">
                <FilterPagination query={query} size={size}/>
              </div>

              {!loading && view === "grid" &&
                <div key={this.props.location.pathname + this.props.location.search}
                     className="catalog-products pb4">
                  <Card.Group itemsPerRow={showSidebar ? 4 : 5} doubling>
                    {products.map( product => <ProductCard key={product.map_id} product={product}/> )}
                  </Card.Group>
                </div>}

              {!loading && view === "list" &&
                <div key={this.props.location.pathname + this.props.location.search}
                     className="catalog-products catalog-products--list">
                  {products.map( ( product, index ) => <ProductListItem
                    index={index}
                    key={product.map_id} product={product}
                    search={currentSearch}/> )}
                </div>}
            </div>

          </div>
        </React.Fragment>}

      </Container>

      {showProductSearch && <div className="tc pt4 pb4">
        <FilterPagination query={query} size={size}/>
      </div>}

      <Container>
        <WordPressShopComponent key={`category-${categoryId}`} slug={`category-${categoryId}-bottom`}/>
      </Container>
    </div>
  }
}

@withRouter
class FilterForm extends React.Component {

  handleChange = ( e, { value } ) => {
    const { type } = this.props
    const multi = type === "Checkbox"
    const { name, query } = this.props

    const oldValue = query[ name ] || []

    if ( multi ) {
      if ( oldValue.includes( value ) ) {
        query[ name ] = oldValue.filter( e => e !== value )
      } else {
        query[ name ] = [...oldValue, value]
      }
    } else {
      if ( oldValue.includes( value ) ) {
        delete query[ name ]
      } else {
        query[ name ] = [value]
      }
    }

    query.page = 1
    this.props.history.replace( { search: queryString.stringify( query ), state: { preventScrollToTop: true } } )
  }

  render() {
    const { query, name, options, type = "Checkbox" } = this.props
    const multi = type === "Checkbox"
    const values = query[ name ] || []
    const valueById = {}
    if ( multi ) {
      values.forEach( e => {
        valueById[ e ] = true
      } )
    } else {
      valueById[ values ] = true
    }
    const FilterComponent = Filters[ type ] || Filters[ "Checkbox" ]
    return (
      <Form>
        <FilterComponent onChange={this.handleChange}
                         options={options}
                         multi={multi}
                         valueById={valueById}
                         query={query}/>
      </Form>
    )
  }
}

const Filters = {
  Checkbox: function CheckboxFilter( { onChange, options, multi, valueById, query } ) {
    return <div>
      <Form.Group grouped>
        {options.map( option => {
          let isChecked = query[ name ] === option
          if ( multi ) {
            isChecked = valueById[ option ]
          }

          if ( name === "ArtikelFarbe" ) {
            const color = colors[ option ]
            return <div
              key={option}
              className="color-filter"
            >
              <div className={`color-marker ${query[ name ] === option && "active"}`}
                   style={{ backgroundColor: color }}/>
              <Form.Checkbox
                onChange={onChange} label={option} type="checkbox" checked={query[ name ] === option}
                value={option}/>
            </div>
          }
          return <Form.Checkbox key={option} onChange={onChange} label={translate( `${option}` )} checked={isChecked}
                                value={option}/>
        } )}
      </Form.Group>
    </div>
  },
  Radio: function RadioFilter( { onChange, options, multi, valueById, query } ) {
    return <div>
      <Form.Group grouped>
        {options.map( option => {
          let isChecked = valueById[ option ]

          if ( name === "ArtikelFarbe" ) {
            const color = colors[ option ]
            return <div
              key={option}
              className="color-filter"
            >
              <div className={`color-marker ${query[ name ] === option && "active"}`}
                   style={{ backgroundColor: color }}/>
              <Radio
                onChange={onChange} label={option} type="radio" checked={query[ name ] === option}
                value={option}/>
            </div>
          }
          return <Form.Radio key={option} onChange={onChange} label={option} checked={isChecked}
                             value={option}/>
        } )}
      </Form.Group>

    </div>
  }
}


const getFilterCount = ( query ) => {
  let count = _.size( query )
  if ( query.sort ) count--
  if ( query.dir ) count--
  if ( query.view ) count--
  if ( query.page ) count--
  return count
}

@withRouter
class FilterPagination extends Component {

  handleClick = ( e, data ) => {
    const { query } = this.props
    const { activePage } = data
    query.page = activePage
    this.props.history.replace( { search: queryString.stringify( query ) } )
  }

  render() {
    const { size, query } = this.props
    const { count = shop.config.standards.ITEMS_PER_PAGE || 24, page = 1 } = query
    const totalPages = Math.ceil( size / count )
    if ( totalPages <= 1 ) return null
    return <Pagination
      className={"FilterPagination"}
      onPageChange={this.handleClick}
      activePage={page}
      ellipsisItem={null}
      firstItem={null}
      lastItem={null}
      siblingRange={1}
      totalPages={totalPages}
    />
  }
}


const FilterNavigation = ( { submeta = false, filterFields, query, location, defaultOpen = false, className = "", category } ) => {

  const [sortedFields, setSortedFields] = React.useState( {} )

  React.useEffect( () => {
    if ( !location || !category ) return

    const link = location.pathname + location.search

    historyStore.set( {
                        key: 0,
                        content: category.desc.short_des,
                        link
                      } )

    categoryStore.loadTranslatedFieldsForCategory( category.map_id )
                 .then( res => {

                   let withData = Object.keys( filterFields ).map( fieldName => {
                     let fieldDatas = cmsStore.config[ fieldName ] || []
                     let fieldData = fieldDatas[ 0 ] || {}
                     let displayName = fieldData.text || fieldName
                     return { fieldName, fieldData, displayName, filterValue: filterFields[ fieldName ] }
                   } )

                   const sortedFilterFields = withData.sort( ( a, b ) => {
                     let sortA = Infinity
                     let sortB = Infinity
                     if ( a.fieldData ) sortA = Number( a.fieldData.sort )
                     if ( b.fieldData ) sortB = Number( b.fieldData.sort )
                     if ( isNaN( sortA ) ) sortA = Infinity
                     if ( isNaN( sortB ) ) sortB = Infinity
                     if ( sortA === sortB ) return 0
                     return sortA > sortB ? 1 : -1
                   } )

                   const sortedFields = {}

                   sortedFilterFields.forEach( field => {
                     let text = field.fieldData && field.fieldData.text
                     sortedFields[ text || field.fieldName ] = field
                   } )

                   setSortedFields( sortedFields )
                 } )

  }, [location] )


  return <div className={`FilterNavigation ${className}`}>
    <Accordion as={Menu} vertical>

      {/* FILTER SEGMENT -> SUBCATEGORY NAV*/}
      {/*{category.children.length > 0 &&  <div className="FilterSegment">*/}
      {/*  <div className="active title">*/}
      {/*    <div className={"b black-80 f5"}>Kategorien</div>*/}
      {/*  </div>*/}
      {/*  <Accordion.Content active>*/}
      {/*    <div className="flex flex-column">*/}
      {/*      {category.children.map( cat => {*/}
      {/*        return <div key={cat.map_id} className="pb1">*/}
      {/*          <Button fluid size={"tiny"} basic as={Link} to={`./${cat.map_id}/`}> {cat.title}</Button>*/}
      {/*        </div>*/}
      {/*      } )}*/}
      {/*    </div>*/}
      {/*  </Accordion.Content>*/}
      {/*</div>}*/}

      {
        _.map( sortedFields, ( filter ) => {
          let value = filter.filterValue
          let key = filter.fieldName
          let hidden = false
          // SKIP FILTERS NOT IN CONFIG
          if ( shop.config.pickFilter && shop.config.pickFilter.indexOf( key ) < 0 ) {
            // console.info( `Skipping filter for ${key}` )
            hidden = true
            // return null
          }

          let options = []
          if ( value.values && typeof value.values === "object" ) {
            // data from meta.fields
            options = Object.keys( value.values )
          } else {
            // data from rootFields or meta.submeta
            options = value
          }

          options = options.filter( o => o !== "null" )

          options = options.sort( ( a, b ) => {
            let confA = categoryStore.getFieldConfigForKey( key, a )
            let confB = categoryStore.getFieldConfigForKey( key, b )

            let sortA = confA && confA.sort
            let sortB = confB && confB.sort

            // alphabetically sort
            let s1 = sortA || a
            let s2 = sortB || b
            if ( s1 > s2 ) return 1
            if ( s1 === s2 ) return 0
            if ( s1 < s2 ) return -1
          } )

          const metaData = cmsStore.config[ `${key}ByKey` ]

          if ( metaData ) {
            options = _.sortBy( options, entry => {
              const data = metaData[ entry ]
              return data && data.sort
            } )
          }

          return <FilterSegment
            filter={filter}
            hidden={hidden}
            defaultOpen={true}
            key={key}
            query={query}
            name={key}
            title={translate( filter.displayName )}
            options={options}/>
        } )
      }

      {/*<AccordionSegment defaultOpen={true} title={translate( "Kategorie" )} value={false} className={"unlimited-h"}>*/
      }
      {/*	<NavigationSidebar category={category} showTitle={false} />*/
      }
      {/*</AccordionSegment>*/
      }

    </Accordion>
  </div>
}


@withRouter
class AccordionSegment extends Component {

  state = {
    isActive: this.props.defaultOpen,
  }

  handleClick = () => {
    this.setState( { isActive: !this.state.isActive } )
  }

  handleClear = () => {
    this.props.history.replace( `/collection/` )
  }

  render() {
    const { isActive } = this.state
    const { title, value, children, className } = this.props
    return <Menu.Item className={`FilterSegment ${className} ${isActive ? "filter-active" : "filter-passive"} `}>
      {value &&
        <Button className="clear-filter primary animate fadeIn" floated="left" circular icon={"close"} size="tiny"
                onClick={this.handleClear}/>}
      <Accordion.Title
        active={isActive}
        content={title}
        onClick={this.handleClick}/>
      {(value) && <div className="active-value pl3 animate fadeIn pv2 black-50 f7">{value}</div>}
      <Accordion.Content active={isActive}>
        {children}
      </Accordion.Content>
    </Menu.Item>
  }
}

@withRouter
class FilterSegment extends Component {

  state = {
    isActive: this.props.defaultOpen,
    showFull: false
  }

  handleClick = () => {
    this.setState( { isActive: !this.state.isActive } )
  }

  handleClear = () => {
    const { name, query, options } = this.props
    delete query[ name ]
    this.props.history.replace( { search: queryString.stringify( query ) } )
  }

  render() {
    const { isActive, showFull } = this.state
    const { title, filter = {}, name, query, options, hidden = false, filterConfig = { multi: true } } = this.props
    const { fieldData = {} } = filter
    const { sort, extras = {} } = fieldData
    const value = query[ name ]

    let displayName = value
    if ( Array.isArray( value ) ) {
      displayName = value.join( ", " )
    }

    const OPTIONS_REDUCED_SIZE = 5
    const type = extras.type || "Checkbox"
    let optionsReduced = options
    let hasMoreOptions = options.length > OPTIONS_REDUCED_SIZE

    if ( !showFull && options.length > OPTIONS_REDUCED_SIZE ) {
      optionsReduced = options.slice( 0, 5 )
    }

    if ( hidden ) return null
    const filterSlug = slugify( title )
    return <React.Fragment>
      <Menu.Item className={`FilterSegment filter-${filterSlug}`}>
        {/*<span className="red dib pr2">({sort})</span>*/}
        {/*{hidden && <span className={"f7 white bg-red pa1 "}>{name}</span>}*/}
        <div className="flex flex-row justify-between items-center pt2">
          <div className="w-100">
            {value && <Button className="clear-filter primary" floated="left" circular icon={"close"} basic
                              size="tiny" onClick={this.handleClear}/>}
            <Accordion.Title
              active={isActive}
              content={<TruncatedTitle title={title} length={25} className={"b black-80 f5 "}/>}
              onClick={this.handleClick}/>
          </div>

        </div>
        {(!isActive && value) &&
          <div className="active-value pl3 animate fadeIn pv2 black-50 f7">{displayName}</div>}
        {isActive && <Accordion.Content active={isActive}>
          <FilterForm type={type} options={optionsReduced} name={name} query={query}
                      multi={filterConfig.multi}/>
          {hasMoreOptions && <React.Fragment>
            <div className="pv3">
              <a href={"#!"} onClick={() => {
                this.setState( { showFull: !this.state.showFull } )
              }} className={"f7 black dib b pv2  "}>
                {showFull && <span>{translate( "Weniger anzeigen" )}</span>}
                {!showFull && <span>{translate( "Alle anzeigen" )}</span>}
                <span className="black-60"><Icon name={"chevron right"}/></span></a>
            </div>


          </React.Fragment>}
        </Accordion.Content>}
      </Menu.Item>
    </React.Fragment>
  }
}

let lastFilter = false

const TruncatedTitle = ( { title, length, className = "" } ) => {
  if ( title.length > length ) {
    return <div className={className}>{title.substr( 0, length )}...</div>
  } else {
    return <div className={className}>{title}</div>
  }
}

const getDefaultFilterSearch = () => {
  return lastFilter || `?sort=${shop.config.filter_defaults.sort || "des"}`
}

const SelectCount = ( { count = shop.config.standards.ITEMS_PER_PAGE, onChange } ) => (
  <Dropdown trigger={<span className="b">{count}</span>}>
    <Dropdown.Menu>
      <Dropdown.Item onClick={() => {
        onChange( "12" )
      }} text="12"/>
      <Dropdown.Item onClick={() => {
        onChange( "24" )
      }} text="24"/>
      <Dropdown.Item onClick={() => {
        onChange( "48" )
      }} text="48"/>
      <Dropdown.Item onClick={() => {
        onChange( "64" )
      }} text="64"/>
    </Dropdown.Menu>
  </Dropdown>
)



// WEBPACK FOOTER //
// ./src/pages/FilterPage.js